import React from "react";
import BaseLayout from "../layout/base/BaseLayout";
import Content from "../components/Content";
import { Box } from "@mui/material";
import Seo from "../components/Seo";

const TERMS_HTML = `
      <ol>
        <li>
          The promoter of this Survey is SlashData Ltd (the
          “Promoter”), a company incorporated in England with number 05614666 whose
          registered address is at Belmont&nbsp; House, Shrewsbury, Shropshire SY2 6LG
          - United Kingdom. This Survey, its contents and questions, and the
          methodology are Copyright of SlashData Ltd, all rights reserved.
        </li>
        <li>
          The promoter reserves the right to amend the Terms and Conditions,
          pertaining to the end and close dates of each survey.
        </li>
        <li>The Promoter may pay Entrants to participate in the Surveys. This payment is the incentive ("the Incentive").</li>
        <li>
          To the full extent permitted by law, the Promoter will not be liable for any
          injury, damages, expenses, or loss whatsoever (whether direct or
          inconsequential) to persons or property as a result of any person accepting or using any Incentive, including without
          limitation non-receipt of any Incentive or damage to any Incentive in transit.
        </li>
        <li>
          Each entry must be entered in accordance with these Terms and Conditions. By
          entering the Survey, each Entrant agrees to be bound by these Terms and Conditions.&nbsp;
        </li>
        <li>
          The Promoter may at its total and absolute discretion refuse to award any
          incentive to any Entrant who fails to comply with these Terms and
          Conditions.&nbsp;
        </li>
        <li>
          The Promoter values genuine and real responses to the Survey and as such
          will not accept entries that are not in accordance with these Terms and
          Conditions. All relevant instructions on the Promoter’s survey page form
          part of these Terms and Conditions. Entrants agree that the Promoter may use
          their entry and any personal, non-identifying details provided to the
          Promoter for the purposes of creating research reports, website articles and
          other research products and that the Promoter retains the right to
          distribute, share and use their entry and response to this Survey in a
          non-identifying fashion.
        </li>
      </ol>
      <h2><strong>Survey</strong></h2>
      <ol>
        <li>
          The Survey opens on 11th February 2026 and is set to close on 23rd February 2025
          (“Survey Period”). Final dates are liable to change without notice.
        </li>
        <li>
          Entry for the Survey is subject to the entrant satisfactorily completing the survey and may include providing a valid email address
          (the “Entrant”). In order for an entrant to be eligible for the incentive reward,
          the entrant should first register to take the Survey using a valid email
          address. In order for the Promoter to analyse and process the results of the
          Survey, further details, such as the IP address of the Entrant will be
          collected. However, such IP addresses will not be used otherwise, nor will
          it be distributed to third parties.
        </li>
        <li>
          Any entry received after the closing date will be deemed invalid. No
          responsibility is accepted for late, lost, delayed or misdirected entries.
          The Promoter reserves the right to extend or reduce the Survey Period, at
          any time during the survey.
        </li>
        <li>
          Individual emails will be sent by the Promoter’s Incentive partner; Tremendous
          to satisfactorily Entrants giving them 5 working days to claim their incentive.
        </li>
        <li>
          Employees or family members of employees of the Promoter or any person
          directly or indirectly involved in the organisation are not eligible for
          an incentive.
        </li>
        <li>
           The Promoter will check and
          remove, at its own undisputable discretion, responses from Entrants who the
          Promoter believes are not involved in software development areas
          without providing notice. Only persons who are involved in 
          software development are eligible to enter as
          described in the Terms and Conditions.
        </li>
        <li>
          Respondents who are frequently removed from our Surveys may be banned from
          participating in future Surveys.
        </li>
        <li>
          Please note that it is not always possible for the Promoter to provide
          Incentives to individuals who are located outside of the European Union or the
          UK. In these instances, the Promoter will provide a substitute to the Incentive
          (or an element of the Incentive) for a Incentive of equal value. The Promoter is not
          responsible for Customs, Tax charges or any other costs that may arise in
          order for the individual to take receipt of the Incentive.&nbsp;
        </li>
        <li>
          The Promoter will never charge an Entrant any fee for the value
          of the Incentive, nor will it demand from the Winner any payment against the
          value of such Incentive.
        </li>
        <li>
          Although the Promoter will normally cover the Incentive delivery expenses at the
          Entrant's address, there might be rare occasions where the Entrant may be
          requested by local authorities to pay local delivery costs. Such costs are
          not related with the Incentive nor do constitute a fee or income for the
          Promoter in any way whatsoever. The Promoter is not responsible for those
          fees or costs.
        </li>
        <li>
          Each Incentive must be taken as stated and no compensation will be payable if a
          winner is unable to use the Incentive as stated.&nbsp;
        </li>
        <li>
          The Promoter is not responsible for the failure to deliver a gift card due
          to any circumstances outside of our control (for example, if someone other
          than the Entrant accesses the email account of that individual).
        </li>
        <li>
          In no event shall Promoter be liable to any Entrant in connection with this
          Survey and/or any Incentive related to it for any special, consequential,
          incidental, punitive or special damages, reliance, or other indirect
          damages, including any loss of revenue, profits, or information provided by
          the Entrant by entering the Survey and/or any Incentive related to it.
        </li>
        <li>
          The Promoter shall act in compliance with legislation pertaining to personal
          data protection, particularly with the Data Protection Act 2018. By entering
          this Survey, Entrant agrees and acknowledges that if any personal data is
          provided to the Promoter of the Survey by the Entrant personally, such
          entrance enables the Promoter to process it for the purposes and in
          connection to the Entrant’s participation in the Survey as well as with the
          research and results of it. Security measures are in place to ensure that
          Entrants’ details are not accessible to any unauthorised company or
          individual.
        </li>
      </ol>
      <p>
        The Promoter may need to disclose some personal data such as the Entrant’s
        email address to its Incentive providers for the purpose of delivering the
        Incentive.&nbsp;
      </p>
      <p>By entering the Survey, Entrants verify that:</p>
      <ol>
        <li>
          They agree to be contacted by the Promoter in the future by email about
          current Surveys, becoming a Developer Nation Panelist and Incentives related to them.
        </li>
        <li>
          Entrants’s IP address will be used for the analysis of the results of the
          Survey and the research based on such results.&nbsp;
        </li>
        <li>
          They agree to their contact information being stored in the Promoter’s
          database after the end of the Survey, in order to be used for future
          Surveys.&nbsp;&nbsp;
        </li>
      </ol>
      <h6>
        <strong
          >All disputes arising between Entrants on the one hand and the Promoter
          and/or any of its directors, officers, or employees on the other from or in
          connection with this Terms and Conditions, the Survey that they are related
          to, the Incentive Draws and the delivery of Incentives, shall be settled by the
          Courts of London UK, by application of the English laws.&nbsp;</strong
        >
      </h6>
      <h2><strong>Developer Nation Community&nbsp;</strong></h2>
      <ol>
        <li>
          Entrants to our Surveys may agree to become a member of the Developer Nation
          Community by checking the relevant option in the Sign-up registration pop
          up, as well as by visiting the Developer Nation Community website
          <a
            href="https://www.developernation.net/signup"
            target="_blank"
            rel="noopener noreferrer"
            >https://www.developernation.net/signup</a
          >
        </li>
        <li>
          Members will have a chance to be part of our exclusive research panel
          program (“Panelists”).
        </li>
        <li>
          Members of the Developer Nation Community (“Members”) and Panelists may
          choose to unsubscribe from the Developer Nation Community by contacting
          SlashData Ltd through the email:
          <a
            href="mailto:community@developernation.net"
            target="_blank"
            rel="noopener noreferrer"
            >community@developernation.net</a
          >.&nbsp;
        </li>
        <li>
          If subscribers of the Developer Nation Newsletter choose to unsubscribe from
          the Newsletter at any point, they have the option to do so within the email
          campaigns they may receive or through their notification settings on the
          profile
          <a
            href="https://www.developernation.net/user"
            target="_blank"
            rel="noopener noreferrer"
            >here</a
          >.
        </li>
        <li>
          Members are identified by the email address they provided during the first
          time they registered to the Developer Nation Community. Members and
          Panelists should sign-up to any survey using the same email address. The
          Promoter is not responsible for Members and Panelists who have taken
          multiple surveys using different email addresses. If members and Panelists
          choose to change their email subscription they have the option to do so
          within the email campaigns they may receive or through the “Communication
          Preferences” settings on their profile
          <a
            href="https://www.developernation.net/user"
            target="_blank"
            rel="noopener noreferrer"
            >here</a
          >.
        </li>
      </ol>
      <h2>
        <strong
          >Handling Developer Nation Community Members personal data&nbsp;</strong
        >
      </h2>
      <ol>
        <li>
          By registering their email address, Members and Panelists agree to
          occasionally being contacted by SlashData &amp; the Developer Nation
          Community for updates regarding Incentive;
        </li>
        <li>
          By joining the Developer Nation Community or Panel Program, Members and
          Panelists agree that the Promoter may contact them again regarding this
          Survey and future potential surveys on topics related to software
          development. Under no circumstances will SlashData contact the
          Members requiring them to pay any amount, fee or other cost in relation to
          any Survey or Incentive Draw.&nbsp;
        </li>
        <li>
          It is acknowledged that the Promoter will process Members’ and Panelists’
          personal data for the purposes and in connection to the Member’s and
          Panelists participation in the Survey, the research and results of it as
          well as the points earned by the Members and Panelists&nbsp; for the Surveys
          they participate in, regardless of the Member’s and Panelist’s choice to
          receive marketing emails.
        </li>
        <li>
          Members and Panelists&nbsp; agree that the Promoter may use their entry and
          any personal, non-identifying details provided to the Promoter for the
          purposes of creating research reports, website articles and other research
          products and that the Promoter retains the right to distribute, share and
          use their entry and response to this Survey in a non-identifying
          fashion.&nbsp;
        </li>
        <li>
          All data provided by the Members and Panelists to the Promoter will be
          anonymised (removing any identifying information) before distribution to any
          other third party, except for the purposes of providing Incentives through
          third-party sponsors.&nbsp;
        </li>
        <li>
          Members and Panelists may save their Survey participation at any point in
          the Survey and may return to complete the Survey at any time whilst the
          survey is live, given that they’ve provided a valid email address.&nbsp;
        </li>
      </ol>
      <ul>
        <li>
          It is the 3rd party Community manager’s responsibility to contact the winner
          for any permission needed in additional communications related to the Survey
          and the specific Partner/Community Incentive Draw.&nbsp;
        </li>
        <li>
          No communication entailing all or part of Winner’s details is allowed
          without his/her prior consent.&nbsp;
        </li>
      </ul>
`;

const TermsPage = () => {
  const pageData = {
    title: {
      html: "<h1>Survey Terms & Conditions</h1>",
      text: "Survey Terms & Conditions",
    },
    text: {
      html: TERMS_HTML,
      text: "Website Terms and Conditions of Use",
    },
  };

  return (
    <BaseLayout page="terms">
      <Box
        component={Content}
        sx={{
          p: "12px",
        }}
        {...pageData}
      />
    </BaseLayout>
  );
};

export const Head = () => {
  return (
    <Seo
      meta={{
        title: "Survey Terms and Conditions | Developer Nation",
        description:
          "Developer Nation Survey Terms and Conditions — SlashData Ltd.",
      }}
    />
  );
};

export default TermsPage;
